import IExistingClient from "./IExistingClient";

export class ExistingClient implements IExistingClient
{
    constructor(public cuid: number)
    {
    }
}
